import { ACTION_TYPES } from '../utils/Constants';

const initialState = {
    unReadCountDetails: [],
    unReadMessageCount: 0,
    receiverUserId: '',
    senderUserId: '',
    receiverUnReadMessageCount: 0,
};

const UnreadReducerCount = (state = initialState, action) => {
    switch (action.type) {
        case ACTION_TYPES.UPDATE_UNREAD_MESSAGE_COUNT:
            return {
                ...state,
                unReadMessageCount: action.payload.unReadMessageCount,
                receiverUserId: action.payload.receiverUserId,
                senderUserId: action.payload.senderUserId,
                unReadCountDetails: action.payload.unReadCountDetails,
            };
        default:
            return state;
    }
};

export default UnreadReducerCount;
